import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { ids } from 'app/area/administration/constants';
import { AccessPerson } from 'app/components/access-panel/shared/types';

interface RoleEditMenuComponentProps {
  id: number;
  optionsFetching: boolean;
  accessPerson: AccessPerson;
  labelDelete: string;
  labelCancel: string;
  labelDescription: string;
  labelDuplicate: string;
  onDelete: (id: number) => void;
}

export const RoleEditMenu: React.FC<RoleEditMenuComponentProps> = (props) => {
  const { id, optionsFetching, accessPerson, labelDelete, labelCancel, labelDescription, labelDuplicate, onDelete } = props;

  const handleDelete = onDelete ? () => onDelete(id) : undefined;
  const handleDuplicate = () => navigate.toDuplicateRole(id);

  const canDelete = !!(accessPerson && accessPerson.delete && handleDelete);
  const canDuplicate = !!(accessPerson && accessPerson.edit && handleDuplicate);

  return (canDuplicate && <MeatballMenu id={ids.list_search_item(id)}>
    {canDuplicate && <li>
      <button type="button" className="dropdown-item" onClick={handleDuplicate} disabled={optionsFetching}>
        {labelDuplicate}
      </button>
    </li>}  
    {canDelete && <li>
      <PromptConfirmationModal
        title={labelDelete}
        description={labelDescription}
        continueText={labelDelete}
        cancelText={labelCancel}
        onContinue={handleDelete}>
        <button type="button" className="dropdown-item" disabled={optionsFetching}>{labelDelete}</button>
      </PromptConfirmationModal>
    </li>}
  </MeatballMenu>);
};
